export default __webpack_public_path__ + "static/media/image-profile-cover-photo-(mobile).66f2821b.svg";